<div class="footer">
</div>
<ng-template ngbModalContainer></ng-template>



// WEBPACK FOOTER //
// ./src/app/layouts/footer/footer.component.html